import { queryOptions } from "@tanstack/react-query";

import { listEducationApplications } from "./api";

export const educationQueryKeys = {
  all: ["education", "applications"] as const,
  applications: (userId: string, page: number, limit: number) => ["education", "applications", userId, page, limit] as const,
};

export function educationApplicationsQueryOptions(userId: string, page: number, limit = 10) {
  return queryOptions({
    queryKey: educationQueryKeys.applications(userId, page, limit),
    queryFn: () => listEducationApplications(page, limit),
  });
}
